import { t } from 'i18next';
import Swal from 'sweetalert2';

import { EAlertType } from 'enums/alertType';

let blockAdditionalAlerts = false;
export const fireAlert = async (
	type: EAlertType,
	title: string,
	text: string,
	milliseconds?: number
) => {
	if (blockAdditionalAlerts) {
		return;
	}
	try {
		blockAdditionalAlerts = true;
		if (!milliseconds) {
			milliseconds = 5000;
		}

		let color = '#fff';
		switch (type) {
			case 0:
				color = '#d1e7dd';
				break;
			case 1:
				color = '#fff3cd';
				break;
			case 2:
				color = '#f8d7da';
				break;
		}

		const toast = Swal.mixin({
			background: color,
			customClass: {
				confirmButton: 'btn btn-primary',
				cancelButton: 'btn btn-danger',
				closeButton: `alert-${type}`,
				popup: `alert alert-${type}`,
				container: 'z-index-5000',
			},
			position: 'top-end',
			showCloseButton: true,
			showConfirmButton: false,
			html: text,
			timer: milliseconds,
			title: title,
			toast: true,
		});
		await toast.fire();
	} finally {
		blockAdditionalAlerts = false;
	}
};

export async function fireShoppingCartAlert() {
	const toast = Swal.mixin({
		background: '#d1e7dd',
		customClass: {
			confirmButton: 'btn btn-primary',
			cancelButton: 'btn btn-danger',
			closeButton: 'alert-success',
			popup: 'alert alert-success',
		},
		position: 'bottom-left',
		icon: 'success',
		showCloseButton: true,
		showConfirmButton: false,
		html: t('shoppingCart:SUCCESSFULLY_ADDED'),
		timer: 3000,
		title: t('header:SHOPPING_CART'),
		toast: true,
	});
	await toast.fire();
}

export async function fireNoDefaultShoppingCartAlert() {
	const toast = Swal.mixin({
		background: '#f8d7da',
		customClass: {
			confirmButton: 'btn btn-primary',
			cancelButton: 'btn btn-danger',
			closeButton: 'alert-danger',
			popup: 'alert alert-danger',
		},
		position: 'bottom-left',
		icon: 'error',
		showCloseButton: true,
		showConfirmButton: false,
		html: t('shoppingCart:NO_DEFAULT_SHOPPING_CART_FOUND'),
		timer: 3000,
		title: t('header:SHOPPING_CART'),
		toast: true,
	});
	await toast.fire();
}
